export const isTMA = () => {
  return (
    'TelegramWebviewProxy' in window &&
    typeof (window.TelegramWebviewProxy as any).postEvent === 'function'
  );
};
